import { mapExpenseToChartData } from "web_myplann/Finances/Helpers/mapExpenseToChartData";
import { mapIncomeToChartData } from "web_myplann/Finances/Helpers/mapIncomeToChartData";
import { useFinanceEntries } from "web_myplann/Finances/Hooks/useFinanceEntries";
import { useSyncFinanceState } from "web_myplann/Finances/Hooks/useSyncFinanceState";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";

export const useFinanceChartData = () => {
	const { t } = useResource();
	const { incomeEntries, expenseEntries, totalIncome, totalExpenses } =
		useFinanceEntries();

	useSyncFinanceState();

	return {
		incomeData: incomeEntries.map(mapIncomeToChartData),
		expenseData: expenseEntries.map((expense) =>
			mapExpenseToChartData(expense, t),
		),
		totalIncome,
		totalExpenses,
	};
};
